import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    padding: '15px 40px 0',
    margin: '-18px 0 0',
    overflow: 'auto',
    maxHeight: 'calc(100% - 160px)',
    ['@media (max-width:600px)']: {
      padding: '25px 15px 0',
      height: 'calc(100% - 188px)',
      maxHeight: 'none'
    }
  },
  afterElement: {
    flex: '0 0 285px',
    margin: '0 8px'
  },
  item: {
    width: '283px',
    border: '1px solid #e2ebf6',
    borderRadius: '3px',
    overflow: 'hidden',
    margin: '0 8px 30px',
    ['@media (max-width:735px)']: {
      width: '345px'
    }
  },
  photo: {
    width: '100%',
    height: '148px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundColor: '#E2F5F8',
    marginBottom: '15px',
    ['@media (max-width:735px)']: {
      height: '180px'
    }
  }
});

export default useStyles;
